import { render } from "./DashboardMarginChart.vue?vue&type=template&id=caaf9fce"
import script from "./DashboardMarginChart.vue?vue&type=script&lang=js"
export * from "./DashboardMarginChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__